import each from 'lodash/each';
import find from 'lodash/find';

export const marketplacePages = (state, getters, rootState) => {
  let page = parseInt(rootState.route.params.page) || 1,
    numPages = state.maxPages < 5 ? state.maxPages : 5,
    pages = [];

  if (page <= Math.ceil(numPages / 2)) {
    for (let i = 1; i <= numPages; i++) {
      pages.push(i);
    }
  } else if (page > state.maxPages - Math.floor(numPages / 2)) {
    for (let i = state.maxPages; i > state.maxPages - numPages; i--) {
      pages.push(i);
    }
    pages.reverse();
  } else {
    return [page - 2, page - 1, page, page + 1, page + 2];
  }

  return pages;
};

export const formattedProductType = state => {
  let productType = find(state.productTypes, productType => productType.id == state.selectedProductType);

  return productType ? productType.name : null;
};

export const hasCategoriesAndProductTypes = state => {
  return state.productTypes && state.categories;
};

export const selectedSortQuery = state => {
  return state.selectedSort !== state.defaultSort ? find(state.sortOptions, option => option.key === state.selectedSort).value : null;
};

export const selectedSortText = state => {
  return find(state.sortOptions, option => option.key === state.selectedSort).value;
};

export const selectedSubSubCategory = state => {
  if (!state.selectedCategory || !state.selectedCategory.parent) {
    return null;
  }

  let subSubCategory = find(state.categories['sub-sub'], category => category.id === state.selectedCategory.id);

  return subSubCategory;
};

export const selectedSubCategory = (state, getters) => {
  if (!state.selectedCategory || !state.selectedCategory.parent) {
    return null;
  }

  let subCategory;

  if (getters.selectedSubSubCategory) {
    subCategory = find(state.categories.sub, category => category.id === getters.selectedSubSubCategory.parent_id);
  } else {
    subCategory = find(state.categories.sub, category => category.id === state.selectedCategory.id);
  }

  return subCategory;
}

export const selectedParentCategory = (state, getters) => {
  if (!state.selectedCategory) {
    return null;
  }

  if (!state.selectedCategory.parent) {
    return state.selectedCategory;
  }

  if (getters.selectedSubCategory) {
    return find(state.categories.parent, category => category.id === getters.selectedSubCategory.parent_id);
  }
};